module.exports = __webpack_public_path__ + "img/cool@2x.944e6e1.webp";